{
  "version": 1,
  "asset_id": "003e1cc6-671d-417f-99f0-bc32527a61bb",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/003e1cc6-671d-417f-99f0-bc32527a61bb/destination-roofing-owner-sales-team-crystal-river-fl-360w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/003e1cc6-671d-417f-99f0-bc32527a61bb/destination-roofing-owner-sales-team-crystal-river-fl-360w.webp",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-360w.webp",
  "size": 13854,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:45Z"
}
